import { useEffect, useState } from 'react';
import api from '../../axios/axios'
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { setPriceFilteredProducts } from '../../redux/product/productSlice';
const Sorting = () => {
      const [sortedProducts, setSortedProducts] = useState([]);
      const dispatch=useDispatch()
     useEffect(()=>{
          if(sortedProducts.length!=0){
            fetchSortedProducts()
          }
     },[sortedProducts])

     const fetchSortedProducts=async()=>{
        try{
       const response=await api.get('user/getSortedProducts',{
        params:{
            sortedProducts:sortedProducts
        }
       })
       dispatch(setPriceFilteredProducts({
        priceFilteredProducts: response.data}))
        }catch(error){
            Swal.fire("Something went wrong")
        }
     }
  return (
    <div className="mb-6">
      <label htmlFor="sorting" className="text-gray-700 font-medium mr-4">Sort by:</label>
      <select
        id="sorting"
        onChange={(e) => setSortedProducts(e.target.value)}
        className="p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        <option value="asc">Price: Low to High</option>
        <option value="desc">Price: High to Low</option>
      </select>
    </div>
  );
};

export default Sorting;